import { ThanksSection as ThanksSectionUI } from "@repo/ui-parkmobile/sections/ThanksSection";
import type { ThanksSection } from "@/generated/sb";
import { sectionTitleResolver } from "@/lib/storyblok/adaptors";

export type ThanksSectionProps = {
  blok: ThanksSection;
};

export function ThanksSection({ blok, ...props }: ThanksSectionProps) {
  return (
    <ThanksSectionUI
      {...props}
      head={sectionTitleResolver(blok.head)}
      mode={blok.mode}
      id={blok.anchor}
    />
  );
}
